import { gql } from '@apollo/client';
export const sendReminderToSignatoriesMutation = gql `
  mutation sendReminderToSignatoriesMutation($id: UUID!) {
    updateSignRequest(id: $id, args: { resend: true }) {
      id
    }
  }
`;
